export const Settings = {
    server: process.env.REACT_APP_API_ROOT
}